import React, { useState } from 'react';
import { Header } from './Header';
import ApiCall from '../utils/ApiCall';
import tr from "date-fns/locale/tr"; // the locale you want
import subDays from "date-fns/subDays";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import { Button } from '@material-ui/core';

registerLocale("tr", tr); // register it with the name you want

const ShuttleList = () => {
    const [list, setList] = useState([]);
    const [date, setDate] = useState(new Date());

    const handleShuttle = async () => {
        var params = {
            date: date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        }
        const response = await ApiCall('agency/GetShuttlePassengerCount?date=' + date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear(), 'get', null, true);
        setList(response.data);
    }

    return (
        <div className="container">
            <Header />


            <>
                {/* <div className="row">
                    <div className="col-md-12 textCenter">
                        <h3>
                            Servis Listesi
                        </h3>
                    </div>
                </div> */}
                <div>
                    <div className="row">
                        <div className="col-md-2">
                            <h5>
                                Servis Tarihi
                            </h5>
                        </div>
                        <div className="col-md-2">
                            <DatePicker dateFormat="dd.MM.yyyy" minDate={subDays(new Date(), 7)} locale="tr"
                                className="form-control w40"
                                selected={date}
                                onChange={(e) => setDate(e)}>
                            </DatePicker>
                        </div>
                        <div className="col-md-2">
                            <Button variant="contained" onClick={handleShuttle} className="w100 fr" style={{ 'textTransform': 'none' }} color="primary">Servis Sorgula</Button>
                        </div>
                    </div>
                </div>
            </>
            <hr />
            {
                list && list.data &&
                <>
                    <div className="row">
                        <div className="col-md-12 textCenter">
                            <h3>
                                Servis Listesi Dökümü
                            </h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <b>
                                Servis Yeri
                            </b>
                        </div>
                        <div className="col-md-4">
                            <b>
                                Servis Zamanı
                            </b>
                        </div>
                        <div className="col-md-4">
                            <b>
                                Kişi Sayısı
                            </b>
                        </div>
                    </div>
                </>
            }

            {
                list && list.data && list.data.map((info, index) =>
                    <div className={`row ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`} key={index}>
                        <div className="col-md-4">
                            {info.StationName}
                        </div>
                        <div className="col-md-4">
                            {info.ShuttleTime}
                        </div>
                        <div className="col-md-4">
                            {info.PassengerCount}
                        </div>

                    </div>
                )
            }

            {
                list && !list.data &&
                <div className="row">
                    <div className="col-md-12 textCenter">
                        <h5>
                            {list.message}
                        </h5>
                    </div>
                </div>
            }
        </div >
    );

}

export default ShuttleList;